import { Injectable, inject } from '@angular/core';
import { TitleStrategy, RouterStateSnapshot } from '@angular/router';
import { UiService } from '../services/ui.service';

@Injectable({ providedIn: 'root' })
export class AppTitleStrategy extends TitleStrategy {
  private uiService = inject(UiService);

  override updateTitle(routerState: RouterStateSnapshot): void {
    const title = this.buildTitle(routerState);
    const finalTitle = title ?? '';

    // Usamos requestAnimationFrame para no bloquear el hilo principal durante la carga
    requestAnimationFrame(() => {
      this.uiService.setPageTitle(finalTitle);
    });

    // Cambiamos el nombre de la pestaña del navegador
    if (finalTitle) {
      document.title = `KronoFlow - ${finalTitle}`;
    } else {
      document.title = 'KronoFlow';
    }
  }
}